import { IGetAssistenciaCategoriaDropDownUseCase } from "../../../presentation/useCases/read/get_assistencia_categoria_drop_down_use_case";
import { CategoriaAssistenciaDropDown } from "../../models/categoria_assistencia_dropdown";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAssistenciaCategoriaDropDownUseCase
 */

export class GetAssistenciaCategoriaDropDownUseCase implements IGetAssistenciaCategoriaDropDownUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getAssistenciaCategoriaDropDown(
  ): Promise<CategoriaAssistenciaDropDown[]> {
    return await this.repository.getAssistenciaCategoriaDropDown();
  }
}
